import { API } from "aws-amplify";
import * as queries from "../graphql/queries";
import * as mutations from "../graphql/mutations";

const diseases = new function() {

	// fixes bugs in amplify mock API handling
	let fixed_getDisease = queries.getDisease.replace(/\s_\w+/g, '');
	let fixed_listDiseases = queries.listDiseases.replace(/\s_\w+/g, '');
	let fixed_diseasesSortedByName = queries.diseasesSortedByName.replace(/\s_\w+/g, '');
	let fixed_diseasesSortedByUpdatedAt = queries.diseasesSortedByUpdatedAt.replace(/\s_\w+/g, '');
	let fixed_createDisease = mutations.createDisease.replace(/\s_\w+/g, '');
	let fixed_updateDisease = mutations.updateDisease.replace(/\s_\w+/g, '');
	let fixed_deleteDisease = mutations.deleteDisease.replace(/\s_\w+/g, '');

	let baseFind = function(graphql, {query, limit, token}) {
		return {
			query: graphql,
			authMode: 'AWS_IAM',
			variables: {
				filter: {
					removed: {
						ne: true
					}
				},
				limit: limit,
				nextToken: token
			}
		};
	};

	this.indexes = {
		main: {
			name: 'listDiseases',
			key: 'normalizedName',
			build: function ({query, limit, token}) {
				let q = baseFind(fixed_listDiseases, {query, limit, token});
				q.variables.filter.normalizedName = {
					contains: query.toLowerCase()
				};
				return q;
			}
		},
		name: {
			name: 'diseasesSortedByName',
			key: 'normalizedName',
			build: function ({
				query,
				limit,
				token = undefined,
				get_after = undefined
			}) {
				let q = baseFind(fixed_diseasesSortedByName, {query, limit, token});
				q.variables.gsiPartition = 'OK';
				q.variables.normalizedName = {
					between: [(get_after || query || '_'), query + 'zzzzz']
				};
				return q;
			}
		},
	};

	this.get = async function(normalizedName) {
		let r = await API.graphql({
			query: fixed_getDisease,
			authMode: 'AWS_IAM',
			variables: {
				normalizedName: normalizedName
			}
		});
		return r.data.getDisease;
	};

	this.find = async function({
		query,
		limit = 1000,
		token = undefined,
		index = 'name',
		get_after = undefined}
	) {
		let results = [];
		let _index = this.indexes[index] || this.indexes['name'];
		while (results.length < limit && token !== null) {
			let q = _index.build({
				query: query.toLowerCase(),
				limit, token, get_after
			});
			let r = await API.graphql(q);
			results = results.concat(r.data[_index.name].items);
			token = r.data[_index.name].nextToken;
		}
		let finalResults = results.slice(0, limit);
		finalResults.next = null;
		if (token || results.length > limit) {
			// should we provide functions for next/previous, here?
			// could be useful in building fore/back-ward looking `Collection`
			/* finalResults.next = () => {
				return this.find({
					query, limit, _index,
					get_after: finalResults[limit - 1][_index.key] + "_",
				});
			} */
			finalResults.next = {
				query, limit, index,
				get_after: finalResults[limit - 1][_index.key] + '_'
			};
		}
		return finalResults;
	};

	this.add = async function(disease) {
		let existing = await this.get(disease.normalizedName);
		if (existing) {
			throw Error("Disease already exists!");
		} else {
			let r = await API.graphql({
				authMode: "AMAZON_COGNITO_USER_POOLS",
				query: fixed_createDisease,
				variables: {
					input: disease
				}
			});
			console.log('created disease', r);
			return r;
		}
	};

	this.update = async function(disease) {
		let r = await API.graphql({
			authMode: "AMAZON_COGNITO_USER_POOLS",
			query: fixed_updateDisease,
			variables: {
				input: disease
			}
		});
		console.log('updated disease', r);
		return r;
	};

	this.put = async function(disease) {
		disease.gsiPartition = 'OK';
		try {
			return await this.update(disease);
		} catch (e) {
			console.info("Cannot update disease. Attempting to add.", disease, e);
			return await this.add(disease);
		}
	};

	this.remove = async function(disease) {
		let r = await API.graphql({
			authMode: "AMAZON_COGNITO_USER_POOLS",
			query: fixed_deleteDisease,
			variables: {
				input: disease
			}
		});
		console.log('deleted disease', r);
		return r;
	};

};

Object.freeze(diseases);
export default diseases;
